const defaultOptions = {
  timeout: 1000,
  showProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  position: 'centerBottom',
  zIndexOffset: 2000,
  zIndex: 2000,
  bodyMaxLength: 500,
  titleMaxLength: 100,
  event: 'destroyed'
}

const defaultConfirmOptions = {
  position: 'centerCenter',
  backdrop: 0.8,
  showPositiveButton: true,
  showNegativeButton: true
}

const mergeOptions = (options) => {
  return {
    ...defaultOptions,
    ...options
  }
}

export default {
  install(Vue) {
    Vue.mixin({
      methods: {
        $showSuccess(message, title, options = {}) {
          options = mergeOptions(options)
          return new Promise((resolve) => {
            const toast = this.$snotify.success(message, title, options)
            toast.on(options.event, (toast) => {
              return resolve(toast)
            })
          })
        },
        $showError(message, title, options = {}) {
          options = mergeOptions(options)
          return new Promise((resolve) => {
            const toast = this.$snotify.error(message, title, options)
            toast.on(options.event, (toast) => {
              return resolve(toast)
            })
          })
        },
        $showWarning(message, title, options = {}) {
          options = mergeOptions(options)
          return new Promise((resolve) => {
            const toast = this.$snotify.warning(message, title, options)
            toast.on(options.event, (toast) => {
              return resolve(toast)
            })
          })
        },
        $confirm(message, title = null, options = {}) {
          options = {
            ...defaultConfirmOptions,
            ...options
          }

          return new Promise((resolve) => {
            const buttons = []

            if (options.showPositiveButton)
              buttons.push({
                text: options.positiveText || this.$t('shared.yes'),
                className: options.positiveClass || 'snotify-brb-btn positive ',
                action: () => {
                  this.$snotify.remove(toast.id)
                  toast.on('hidden', (toast) => (toast.config.backdrop = -1))
                  resolve(true)
                }
              })

            if (options.showNegativeButton)
              buttons.push({
                text: options.negativeText || this.$t('shared.no'),
                className: options.negativeClass || 'snotify-brb-btn negative',
                action: () => {
                  this.$snotify.remove(toast.id)
                  toast.on('hidden', (toast) => (toast.config.backdrop = -1))
                  resolve(false)
                }
              })
            const toast = this.$snotify.confirm(message, title, {
              ...options,
              buttons
            })
          })
        }
      }
    })
  }
}
